import gql from 'graphql-tag';

const AUCTION_LIVE_UPDATES_SUBSCRIPTION = gql`
  subscription auctionLiveUpdates(
    $auction_ids: [Int!]!
  ) {
    auctionLiveUpdates(
      auction_ids: $auction_ids
    ) {
      ...AuctionFragment
    }
  }
`;

export default AUCTION_LIVE_UPDATES_SUBSCRIPTION;
